/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
export function find(list, f) {
	return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy(obj, cache = []) {
	// just return if obj is immutable value
	if (obj === null || typeof obj !== 'object') {
		return obj
	}

	// if obj is hit, it is in circular structure
	const hit = find(cache, c => c.original === obj)
	if (hit) {
		return hit.copy
	}

	const copy = Array.isArray(obj) ? [] : {}
	// put the copy into cache at first
	// because we want to refer it in recursive deepCopy
	cache.push({
		original: obj,
		copy
	})

	Object.keys(obj).forEach(key => {
		copy[key] = deepCopy(obj[key], cache)
	})

	return copy
}

/**
 * forEach for object
 */
export function forEachValue(obj, fn) {
	Object.keys(obj).forEach(key => fn(obj[key], key))
}

export function isObject(obj) {
	return obj !== null && typeof obj === 'object'
}

export function isPromise(val) {
	return val && typeof val.then === 'function'
}

export function assert(condition, msg) {
	if (!condition) throw new Error(`[vuex] ${msg}`)
}

export function toJsonDate( date )
{
	let milliSinceEpoch;
	if( typeof date === 'string' )
		milliSinceEpoch = Date.parse( date );
	else if( date instanceof Date )
		milliSinceEpoch = date.getTime( );
	return { $date : milliSinceEpoch }
}

export function isBasicObject( value )
{
	if( typeof value !== 'object' || value === null )
		return false;
	if( Object.prototype.toString.call( value ) !== "[object Object]" )
		return false;
	if( value.constructor && typeof value.constructor === 'object' && !Object.prototype.hasOwnProperty.call( value, 'constructor' ) && value.constructor !== Object && value.constructor.name !== "Object" )
		return false;
	return true;	// Close enough for now; NOTE: gotta make sure to ONLY process own properties!
};

export function getValuetype( value )
{
	let valuetype = typeof value;
	switch( valuetype )
	{
		case 'boolean':
		case 'string':
			return valuetype;
		case 'number':
			if( !isFinite( value ) )
				throw new Error( "Number value is Infinite or NaN" );
			return valuetype;
		case 'object':
			if( value === null )
				return 'null';
			else if( value instanceof Array )
				return 'array';
			else if( !isBasicObject( value ) )
				throw new Error( "Value is a non-basic object; this is not allowed!" );
			else if( value.hasOwnProperty( '$date' ) )
			{
				if( Object.keys( value ).length === 1 && typeof value.$date === 'number' && value.$date % 1 === 0 && isFinite( value.$date ) )
					return 'date';
				throw new Error( "Invalid date object! Must have only 1 field '$date' with integer value." );
			}
			else if( value.hasOwnProperty( '$ref' ) )
			{
				for( let key in value )
					if( key !== '$ref' && key !== '$source' )
						throw new Error( `Reference ($ref) value has invalid property: ${key}` );
				return 'reference';
			}
			else
				return 'object';
		default:
			throw new Error( "Unsupported type: "+ valuetype );
	}
}

export function updateBreadcrumb( route )	// In VUE components, get the route as this.$route
{
	if( !Array.isArray( route.matched ) || route.matched.length < 1 )
	{
		console.warn( "Breadcrumb could not be constructed.. Seems that this route doesn't exist." );
		return [ ];
	}
	let matchedParts = _.last( route.matched ).path.replace( /(^\/)|(\/$)/g, '' ).split( '/' );
	let pathParts = route.path.replace( /(^\/)|(\/$)/g, '' ).split( '/' );
	let processed = [];
	let breadcrumb = [];
	for( let i=0; i < pathParts.length; i++ )
	{
		if( i === 0 && pathParts[i] === '' )
			continue;
		let bcItem = { };
		let pathPart = pathParts[i];
		let matchPart = matchedParts[i];

		if( matchPart.startsWith( ':' ) )
		{
			bcItem.name = pathPart;
			// TODO: Get full item name from storage.
			// = this.getElementName( matchPart.substring( 1 ), pathPart )
		}
		else
			bcItem.name = _.capitalize( pathPart );
		
		processed.push( pathPart );

		bcItem.path = '/'+ processed.join( '/' );
		breadcrumb.push( bcItem );
	}
	return breadcrumb;
}

const RANDOM_CHARS = 'abcdefghijklmnopqrstuvwxyz0123456789';
export function randomString( length = 8 )
{
	let rand = '';
	for ( let i = 0; i < length; i++ ) {
		rand += RANDOM_CHARS.charAt( Math.floor( Math.random( ) * RANDOM_CHARS.length ) );
	}
	return rand;
}


// WEBPACK FOOTER //
// ./src/util.js